module.exports = ".btn-primary{\r\n    margin-right: 10px;\r\n}\r\n.container{\r\n  margin: 20px;\r\n  width: 1000px;\r\n}\r\n/* .addButton{\r\n    width: 25px;\r\n    height: 24px;\r\n    /* background-image: url(./assets/images/AddButton.jpg); \r\n} */\r\n/* .deleteButton{\r\n    width: 24px;\r\n    height: 23px;\r\n    background-image: url('./assets/images/CancelButton.jpg');\r\n} */\r\n.dropdown{\r\n    width: 100%;\r\n    height: 35px;\r\n    border-radius: 4px;\r\n    }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hq-user/hq-user.component.css
// module id = ./src/app/hq-user/hq-user.component.css
// module chunks = main